const topbar = {
    docs: 'مستندات',
    help: 'راهنما',
    subscription: 'اشتراک',
};
export default Object.freeze(topbar);
